<template>
    <div>
        <el-dialog 
            title="双重验证" 
            :visible.sync='dialogVisible' 
            width="30%"
            @close='handleClose'
            :show-close='true'
            :close-on-click-modal='false'   
            :close-on-press-escape='false'
            >
            <div  v-loading='loading'>
                 <div class='titleText'>
                <p class='titleText_p'>管理员已为您设置了双重验证</p>
                <p class='titleText_p'>请向管理员<span class="userManage">{{userManage.userName?userManage.userName:userManageName}}</span>索取验证码进行验证</p>
                </div>
                 <div class="code-input-main">
                    <input class="code-input-main-item" v-for='(item,index) in 6' :value='code[index]' readonly 
                        :class='index===code.length?"active":""'>
                            
                        </input>
                    <input class="code-input-input" v-model="code" maxlength="6" ref='mainInput'/>
                </div>
                <div class="sendButton_c">
                   <button class="sendButton" :disabled='isButtonDisabled' @click='handleSendClick'>
                        {{btnText}}
                    </button> 
                </div>
            </div>
           
            
        </el-dialog>
    </div>
</template>
 
<script>
    export default {
        props:{
            bookId:'',
        },
        data() {
            return {
                code:'',               // 输入验证
                dialogVisible: true,   // 验证框显示
                btnText:'获取验证码',    // 按钮文字
                isButtonDisabled: true,  // 禁用按钮
                userManage: {},         // 管理员信息
                loading: false,          // 加载
            }
        },
        created() {
            this.getblur();
        },
        computed: {
            userManageName(){
                return sessionStorage.getItem('sessionStorage_userManage');
            }
        },
        methods: {
            // 关闭弹框
            handleClose() {
               this.$emit('closeMessage_f',true)
            },
            // 验证按钮发送点击
            handleSendClick(){
                this.getManage();
                 sessionStorage.setItem("sendCodeTime_dd" , new Date().getTime());
                this.getSecond(5*60);
            },
           
            // input获取焦点
            getblur() {
                this.$nextTick(()=>{
                   this.$refs.mainInput.select();
                })
                if(!sessionStorage.getItem("superGetMessage_110")){
                    sessionStorage.setItem("superGetMessage_110" , true);
                    sessionStorage.setItem("sendCodeTime_dd" , new Date().getTime());
                    this.getManage();
                }
                let time =sessionStorage.getItem("sendCodeTime_dd");
                if(time){
                    let now = new Date().getTime();
                    if(now-time<60000){//如果小于一分钟
                        this.getSecond((5*60-(now-time)/1000).toFixed(0));
                    }
                }
            },
            // 定时器
            getSecond(wait){
                let _this=this;
                let _wait = wait;
                // 分钟数
                let minutes = Math.floor(_wait/60);
                // 秒数
                let seconds = Math.floor(_wait%60);
                if(seconds<10){
                    seconds = '0'+seconds
                }
                if(_wait == 0) {
                    if(this.userManage.limit){
                        this.btnText='今日发送次数已达到上限'
                         this.isButtonDisabled = true;
                        return;
                    }else {
                        this.btnText= "获取验证码";
                        this.isButtonDisabled = false;
                        
                    }
                } else {
                    this.isButtonDisabled = true;
                    this.btnText= this.btnText= minutes+':'+seconds+"后重新获取验证码"
                    _wait--;
                    setTimeout(function() {
                        _this.getSecond(_wait);
                    },1000);
                }
            },
            // 获取账套的上级信息并调用短信验证接口
            getManage() {
                this.$http.post('createAccountSet/getAaccountInfo',{ bookId: this.bookId}).then(res=>{
                    this.userManage = res.data.data;
                    sessionStorage.setItem("sessionStorage_userManage" , res.data.data.userName);
                    if(res.data.data.limit) {
                        this.$message({
                            type: 'warning',
                            message: '您今天发送验证码次数已达上限！',
                            showClose: true,
                        })
                        
                    }else {
                        this.$message({
                            type: 'success',
                            message: '已成功发送验证码！',
                            showClose: true,
                        })
                    }
                    
                })
            },
        },
        watch: {
            code(val,oldval){
                if(!val.trim()) {
                    this.code="";
                }
                if(val&&val.length==6){

                    let params={
                        loginName: this.userManage.phone,
                        securityCode: val,
                        bookId: this.bookId
                    }
                    try{
                       this.loading = true;
                       this.$http.post('createAccountSet/LoginEncryptedBook',params).then(res=>{
                         this.loading = false;
                        if(res.data.code == 1) {
                             this.$message({
                                type: 'success',
                                message: res.data.msg,
                                showClose: true,
                            })
                            this.$emit('CloseMessage' , this.bookId);
                            this.$setSessionStorage('notLoginEncryptedBookShow' , true)
                        }

                       })
                    }catch(e) {
                        this.loading = false;
                    }
                  

                }
            },
        }
    }
</script>
<style lang='less'>
.titleText {
    text-align: center;
}
.userManage {
    color: red;
}
.titleText_p {
    padding: 5px 0;
}
.sendButton {
    background-color: transparent;
    border: none;
    outline: none;
}
.sendButton_c {
    margin: 20px 0 0 0;
    text-align: right;
}
.code-input-main {
    text-align: center;
    position: relative;
    .code-input-main-item {
        display: inline-block;
        width: 50px;
        height: 50px;
        opacity: 0.8;
        border: solid #ddd 1px;
        margin: 10px;
        text-align: center;
        padding-bottom: 0;
        font-size: 30px;
        color:#000;
    }
    .active {
        border:1px solid #409EFF;
    }
    .code-input-input {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity:0;
        left: 0;
        top:0;
    }
}
   
</style>


// WEBPACK FOOTER //
// src/components/dialog/messageVerification.vue